import { action } from 'mobx';

import { Countable } from './CountableItem.js';

export class StatusItem extends Countable {
  constructor({ item, shouldSyncAPI, skipQtyValidation, labelsStore }) {
    super({ item, shouldSyncAPI, skipQtyValidation });
    this.replacing = item.replacing || '';
    this.replacingQty = item.replacingQty || 0;
    this.productBarColor = item.productBarColor || '';
    this.productBarText = item.productBarText || '';
    this.skuID = item.skuID;
    this.isObsolete = item.isObsolete;
    this.isSubstitute = !!(this.replacing && this.replacingQty);
    this.isShowReplacingStatus = this.isSubstitute && (this.replacingQty > 1);
    this.hasStatus = Boolean(!this.isSubstitute && this.productBarColor);
    this.labelsStore = labelsStore;
  }

  @action.bound
  changeQty(value = 0) {
    if (this.isDisabled) {
      return;
    }

    if (this.isShowReplacingStatus && this.isLessThenSingleObsolete(value)) {
      this.showTooltip();
    }

    super.changeQty(value);
  }

  showTooltip() {
    this.setCountTooltip({
      msg: this.getReplacingTooltipQtyInfo(),
      class: 'subst-tooltip'
    });
  }

  isLessThenSingleObsolete(value) {
    const newQty = this.quantity + value;

    return newQty < this.quantity && this.quantity === this.replacingQty;
  }

  getReplacingBadgeTxt() {
    let badgeTxt = '';

    if (this.isSubstitute) {
      badgeTxt = this.labelsStore.substReplacingId.replace('#ID#', this.replacing);
    }

    return badgeTxt;
  }

  getReplacingTooltipQtyInfo() {
    const label = this.labelsStore.substReplacingQtyInfo;
    const pattern = /#qty#|#obsolete product ID#|#substitute product ID#/gi;

    return label.replace(pattern, (match) => {
      switch (match) {
        case '#qty#':
          return this.replacingQty;
        case '#obsolete product ID#':
          return this.replacing;
        case '#substitute product ID#':
          return this.skuID;
        default:
          break;
      }
    });
  }

  getReplacingQtyMsg() {
    const label = this.labelsStore.substReplacingQty;
    const pattern = /#qty#|#obsolete product ID#/gi;

    return label.replace(pattern, (match) => {
      switch (match) {
        case '#qty#':
          return this.replacingQty;
        case '#obsolete product ID#':
          return this.replacing;
        default:
          break;
      }
    });
  }
}
